import workflow from 'marketing-website/media/images/pages/marvel-vs-invision/workflow.png';
import usertesting from 'marketing-website/media/images/pages/marvel-vs-invision/usertesting.png';
import invisionAlternative from 'marketing-website/media/images/pages/marvel-vs-invision/invisionAlternative.png';
import prototypes from 'marketing-website/media/images/pages/marvel-vs-invision/Prototypes2x.jpg';
import dashboardImage from 'marketing-website/media/images/pages/enterprise/dashboard@2x.jpg';
import imageEditorImage from 'marketing-website/media/images/pages/enterprise/imageEditor@2x.png';
import organiseImage from 'marketing-website/media/images/pages/enterprise/organise@2x.png';
import posterLogos from 'marketing-website/media/images/pages/enterprise/posterLogos.jpg';
import sharePreview from 'marketing-website/media/images/pages/enterprise/ogPreview.png';

const assetsInv = {
  workflow: {
    alt: 'workflow',
    src: workflow,
    maxWidth: 640,
  },
  usertesting: {
    alt: 'user testing',
    src: usertesting,
    maxWidth: 640,
  },
  invisionAlternative: {
    alt: 'invison alternative',
    src: invisionAlternative,
    maxWidth: 640,
  },
  prototypes: {
    src: prototypes,
    maxWidth: 640,
  },
  dashboard: {
    alt: 'Previews of the Marvel Dashboard',
    src: dashboardImage,
    maxWidth: 725,
  },
  imageEditor: {
    alt: 'Image Editor inside Marvel',
    src: imageEditorImage,
    maxWidth: 530,
  },
  organise: {
    alt: 'Organise your designs, prototypes and user tests in your folders',
    src: organiseImage,
    maxWidth: 660,
  },
  posterLogos: {
    src: posterLogos,
    maxWidth: 642,
  },
  sharePreview: {
    src: sharePreview,
    maxWidth: 1200,
  },
};

export default assetsInv;



// WEBPACK FOOTER //
// ./src/configs/pages/marvel-vs-invision/assets.js